export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-color/src/math.js
// module id = ../../../../d3-color/src/math.js
// module chunks = vendor